import React from 'react';
import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';
import CharacterCount from './CharacterCount.jsx';
import Text from '../../../../Text';

const ResponseInput = ({
  characterLimit,
  responseText,
  onChange,
  label,
  placeholder,
  isDisabled = false,
}) => {
  return (
    <>
      <ResponseLabelWrapper>
        <ResponseLabel>{label}</ResponseLabel>
        <CharacterCount
          characterLimit={characterLimit}
          characters={responseText.length}
        />
      </ResponseLabelWrapper>
      <Input
        maxLength={characterLimit}
        placeholder={placeholder}
        onChange={({ target: { value } }) => onChange(value)}
        disabled={isDisabled}
      />
    </>
  );
};

export default ResponseInput;

export const ResponseLabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ResponseLabel = styled(Text)`
  font-size: 14px;
  color: ${themeGet('colors.black.80')};
  margin: 0 3px 8px;
`;

const Input = styled.textarea`
  height: 100px;
  padding: 11px;
  font-size: 14px;
  resize: none;
`;
